import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {

  private loadingCount = 0;
  private loadingSubject = new BehaviorSubject(false);
  loading$ = this.loadingSubject.asObservable();

  showLoading(status: boolean): void {
    if (status) {
      this.loadingCount++;
      this.loadingSubject.next(true);
    } else {
      this.loadingCount--;

      if (this.loadingCount <= 0) {
        this.loadingCount = 0;
        this.loadingSubject.next(false);
      }
    }
  }

  show(): void {
    this.showLoading(true);
  }

  hide(): void {
    this.showLoading(false);
  }

  resetLoading(): void {
    this.loadingCount = 0;
    this.loadingSubject.next(false);
  }
}